module.exports = __webpack_public_path__ + "img/iosNotch.a370f4.png";